module.exports = __webpack_public_path__ + "static/media/3C.4b755182.svg";